import api from './../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const pabxsStartRequest = () => {
  return {
    type: 'PABXS_START_REQUEST'
  };
};

export const pabxsEndRequest = () => {
  return {
    type: 'PABXS_END_REQUEST'
  };
};

export const getAllPABXsSuccess = ({ data }) => {
  return {
    type: 'PABXS_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllPABXsError = error => {
  return {
    type: 'PABXS_GET_ALL_ERROR',
    payload: error
  };
};

export const addPABXsSuccess = ({ data }) => {
  return {
    type: 'PABXS_ADD_SUCCESS',
    payload: data
  };
};

export const addPABXsError = error => {
  return {
    type: 'PABXS_ADD_ERROR',
    payload: error
  };
};

export const editPABXsSuccess = ({ data }) => {
  return {
    type: 'PABXS_EDIT_SUCCESS',
    payload: data
  };
};

export const editPABXsError = error => {
  return {
    type: 'PABXS_EDIT_ERROR',
    payload: error
  };
};

export const removePABXsSuccess = id => {
  return {
    type: 'PABXS_REMOVE_SUCCESS',
    payload: id
  };
};

export const removePABXsError = error => {
  return {
    type: 'PABXS_REMOVE_ERROR',
    payload: error
  };
};

export const pabxsModifyStore = ({ data }) => {
  return {
    type: 'PABXS_MODIFY_STORE',
    payload: data
  };
};

export const addPABXs = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(pabxsStartRequest());
      const response = await api().post('/api/pabxs', data);
      dispatch(addPABXsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'pabxs',
        data: [response.data]
      });
      formReset();
    } catch (err) {
      dispatch(addPABXsError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(pabxsEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllPABXs = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(pabxsStartRequest());
      const response = await api().get('/api/pabxs', { params });
      dispatch(getAllPABXsSuccess(response));
    } catch (err) {
      dispatch(getAllPABXsError(err));
    } finally {
      dispatch(pabxsEndRequest());
    }
  };
};

export const editPABXs = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(pabxsEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(pabxsStartRequest());
      const id = data._id;
      const response = await api().put('/api/pabxs/' + id, data);
      dispatch(editPABXsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'pabxs',
        data: [response.data]
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/pabxs'));
      }
    } catch (err) {
      dispatch(editPABXsError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removePABXs = id => {
  return async dispatch => {
    try {
      dispatch(pabxsStartRequest());
      await api().delete('/api/pabxs/' + id);
      dispatch(removePABXsSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'pabxs',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'PABX removido com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removePABXsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover PABX.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(pabxsEndRequest());
    }
  };
};

export const restorePABXs = data => {
  return async dispatch => {
    try {
      dispatch(pabxsStartRequest());
      const id = data._id;
      const response = await api().put('/api/pabxs/' + id, data);
      dispatch(editPABXsSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'pabxs',
        data: [response.data]
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'PABX restaurado com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editPABXsError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar PABX.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(pabxsEndRequest());
    }
  };
};
